import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AbstractFieldInterventionEntitiesFilterOptionsComponent } from '@connect-services/client/components/abstract-field-intervention-entities-filter-options/abstract-field-intervention-entities-filter-options.component';
import { FieldInterventionStatusComponent } from '@connect-services/client/components/field-intervention-status/field-intervention-status.component';
import { CheckboxComponent } from '@connect-services/src/lib/components/checkbox/checkbox.component';
import { FieldInterventionEntity } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import StatusEnum = FieldInterventionEntity.StatusEnum;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule, CheckboxComponent, FieldInterventionStatusComponent],
    selector: 'app-entity-status-filter-options',
    styleUrl: 'entity-status-filter-options.component.scss',
    templateUrl: './entity-status-filter-options.component.html',
})
export class EntityStatusFilterOptionsComponent extends AbstractFieldInterventionEntitiesFilterOptionsComponent {
    protected readonly sortStatusByCheck = computed(() =>
        this.sortByCheck<StatusEnum>(this.statuses() ?? [], this.filterEntitiesTableService.filterByParams()?.statuses),
    );
    protected readonly statuses = computed(() => {
        return this.isOnPlanningPage() ? this.statusesPlanning : this.statusesAll;
    });
    // Status classification by business logic
    protected readonly statusesAll = [
        FieldInterventionEntity.StatusEnum.PLANNED,
        FieldInterventionEntity.StatusEnum.ONGOING,
        FieldInterventionEntity.StatusEnum.TO_VALIDATE,
        FieldInterventionEntity.StatusEnum.DONE,
        FieldInterventionEntity.StatusEnum.INVALID,
    ];
    protected readonly statusesPlanning = [
        FieldInterventionEntity.StatusEnum.TODO,
        FieldInterventionEntity.StatusEnum.PLANNED,
    ];

    private readonly router = inject(Router);

    private isOnPlanningPage(): boolean {
        const urlSplit = this.router.url.split('/');
        const isInDetailPanel = /^\(.*\)$/.test(urlSplit.at(-1) ?? '');
        const lastUrlSegment = isInDetailPanel ? urlSplit.at(-2) : urlSplit.at(-1);

        return !!(urlSplit.length && lastUrlSegment === 'planning');
    }
}
